
define('text!ui/template/form/element/input.html',[],function () { return '<input class="input-text" type="text" data-bind="value: value,valueUpdate: \'keyup\',hasFocus: focused,attr: {name: inputName,placeholder: placeholder,\'aria-describedby\': getDescriptionId(),\'aria-required\': required,\'aria-invalid\': error() ? true : \'false\',id: uid,disabled: disabled}">';});

